import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'

import { renderTextField, Submit } from '../form'
import { validRequired, validEmail } from '../form/validate'

import { InputGroup, Center, AuthToken, Column } from './shared'

class ResendConfirmation extends React.Component {
  render() {
    const { handleSubmit, invalid } = this.props
    return (
      <form
        className="qa-resend-confirmation"
        action="/users/confirmation"
        method="post"
        ref={(ref) => (this.form = ref)} // eslint-disable-line
        onSubmit={handleSubmit(() => {
          this.form.submit()
        })}
      >
        <AuthToken />

        <div className="container">
          <div className="row">
            <Column className="col-xs-12 col-md-6 col-md-push-3">
              <Field
                label="Email"
                name="user[email]"
                type="email"
                component={renderTextField}
                validate={[validRequired, validEmail]}
                lessMargin
                readOnly
              />
              <InputGroup>
                <Center>
                  <Submit name="commit" disabled={invalid}>
                    Resend Confirmation Instructions
                  </Submit>
                </Center>
              </InputGroup>
            </Column>
          </div>
        </div>
      </form>
    )
  }
}

const ResendConfirmationForm = reduxForm({
  form: 'ResendConfirmation',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(ResendConfirmation)

export default connect(({ auth }) => ({
  currentUser: auth.currentUser,
  initialValues: {
    user: {
      email: auth.currentUser && auth.currentUser.email,
    },
  },
}))(ResendConfirmationForm)
